import { config, Sentry } from '@xingternal/hops';
import { CaptureContext } from '@sentry/types';

import { debugApolloEnabled, isPreviewOrProduction } from '@/utils/env';

const { sentryDSN } = config;

const onlyOnPreviewOrProduction = (callback: Function): void => {
  if (isPreviewOrProduction()) {
    callback();
  }
};

const captureException = (error: any, info?: CaptureContext): void => {
  onlyOnPreviewOrProduction(() => Sentry.captureException(error, info));
};

const initSentry = (): void => {
  onlyOnPreviewOrProduction(() =>
    Sentry.init({
      dsn: sentryDSN,
    }),
  );
};

const logError = (error: Error) => {
  if (debugApolloEnabled()) console.log(error);
  captureException(error);
};

export { captureException, initSentry, logError };
